var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPdfIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 50,
    viewBox: "0 0 39 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File type icon"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 11",
    d: "M0 8.17635C0 3.953 3.42371 0.529297 7.64706 0.529297H29.2444C32.3033 3.97047 34.7941 6.64699 39 10.8528V41.8234C39 46.0468 35.5763 49.4705 31.3529 49.4705H7.64706C3.4237 49.4705 0 46.0468 0 41.8234V8.17635Z",
    fill: "#5E2750"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Polygon 1",
    d: "M32.9086 11.147C30.486 11.2441 28.5348 9.18074 28.7669 6.76731L29.3491 0.713025L38.986 10.9036L32.9086 11.147Z",
    fill: "#E60000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "PDF",
    d: "M11.1465 25.8301V29H9.66406V20.4688H12.9277C13.8809 20.4688 14.6367 20.7168 15.1953 21.2129C15.7578 21.709 16.0391 22.3652 16.0391 23.1816C16.0391 24.0176 15.7637 24.668 15.2129 25.1328C14.666 25.5977 13.8984 25.8301 12.9102 25.8301H11.1465ZM11.1465 24.6406H12.9277C13.4551 24.6406 13.8574 24.5176 14.1348 24.2715C14.4121 24.0215 14.5508 23.6621 14.5508 23.1934C14.5508 22.7324 14.4102 22.3652 14.1289 22.0918C13.8477 21.8145 13.4609 21.6719 12.9688 21.6641H11.1465V24.6406ZM17.3398 29V20.4688H19.8594C20.6133 20.4688 21.2812 20.6367 21.8633 20.9727C22.4492 21.3086 22.9023 21.7852 23.2227 22.4023C23.543 23.0195 23.7031 23.7266 23.7031 24.5234V24.9512C23.7031 25.7598 23.541 26.4707 23.2168 27.084C22.8965 27.6973 22.4375 28.1699 21.8398 28.502C21.2461 28.834 20.5645 29 19.7949 29H17.3398ZM18.8223 21.6641V27.8164H19.7891C20.5664 27.8164 21.1621 27.5742 21.5762 27.0898C21.9941 26.6016 22.207 25.9023 22.2148 24.9922V24.5176C22.2148 23.5918 22.0137 22.8848 21.6113 22.3965C21.209 21.9082 20.625 21.6641 19.8594 21.6641H18.8223ZM30.0957 25.3848H26.6621V29H25.1797V20.4688H30.5996V21.6641H26.6621V24.2012H30.0957V25.3848Z",
    fill: "#E60000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdfIcon);
export default __webpack_public_path__ + "static/media/PdfIcon.1d73ede247de00ea518c4e919c9190fc.svg";
export { ForwardRef as ReactComponent };